<template>
    <div class="card mt-3 bg-light">
        <div class="card-body">
            <h5 class="card-title">Polling Group {{ pollingGroup.pollingGroupId }}</h5>
            <div class="form-check">
                <input
                    :id="'status-reporting-checkbox' + 'ug-' + uploadGroup.uploadGroupId + 'pg-' + pollingGroup.pollingGroupId"
                    class="form-check-input"
                    type="checkbox"
                    v-model="statusReporting"
                    @change="updateStatusReporting" />
                <label
                    class="form-check-label"
                    :for="'status-reporting-checkbox' + 'ug-' + uploadGroup.uploadGroupId + 'pg-' + pollingGroup.pollingGroupId">
                    Enable Device Status Reporting
                </label>
            </div>
            <tag-selection
                v-for="query in pollingGroup.queryArr"
                :key="query.queryId"
                :query="query"
                :pollingGroup="pollingGroup"
                :uploadGroup="uploadGroup"
                :uploadGroupArr="uploadGroupArr"></tag-selection>
        </div>
    </div>
</template>

<script>
import TagSelection from './TagSelection.vue'

export default {
    data() {
        return {
            statusReporting: false
        }
    },
    components: {
        'tag-selection': TagSelection
    },
    props: ['pollingGroup', 'uploadGroup', 'uploadGroupArr'],
    methods: {
        updateStatusReporting() {
            this.$nextTick(() => {
                if(this.statusReporting) {
                    this.$emit('statusReportingChanged', {
                        value: '1',
                        pollingGroupId: this.pollingGroup.pollingGroupId
                    })
                } else {
                    this.$emit('statusReportingChanged', {
                        value: '0',
                        pollingGroupId: this.pollingGroup.pollingGroupId
                    })
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/upload-group/PollingGroup.vue